<template>
  <div></div>
</template>

<script>
import { showErrorNotification, showSuccessNotification } from '@/utils/notification';

export default {
  async created() { // TODO: Refactor in new auth account component
    try {
      switch (this.$route.query.mode) {
        case 'resetPassword': // Display reset password handler and UI.
          this.$store.dispatch('user/auth/handleResetPasswordValidityCheck', {
            actionCode: this.$route.query.oobCode,
          }).then((userEmail) => {
            // TODO: Remove commit
            this.$store.commit('user/auth/SET_USER', {
              email: userEmail,
            });
            this.$router.push({
              name: 'AuthResetPasswordSetPassword',
              query: {
                email: userEmail,
                actionCode: this.$route.query.oobCode,
              },
            });
          }).catch((error) => {
            this.$router.push({
              name: 'AuthResetPasswordSendEmail',
              params: {
                title: 'Try resetting your password again.',
              },
            });
            showErrorNotification(error.message, 8000);
          });
          break;
        case 'recoverEmail': // TODO: Display email recovery handler and UI.
          this.$router.push({ name: 'Dashboard' });
          break;
        case 'verifyEmail': { // Display email verification handler and UI.
          // A Firebase oobCode is single use, and it is routinely spent before the customer
          // ever clicks: corporate mail scanners (Google Workspace, Outlook ATP) prefetch
          // links in incoming mail, and people click the same link twice. Both cases used to
          // land in the catch below and show the raw Firebase text, "The action code is
          // invalid...", to someone whose address was in fact already verified.
          try {
            await this.$store.dispatch('user/auth/handleVerifyEmail', {
              actionCode: this.$route.query.oobCode,
              continueUrl: this.$route.query.continueUrl,
            });
            this.$router.push({ name: 'Dashboard' });
            showSuccessNotification('Your Email was verified successfully.', 3000);
          } catch (error) {
            // refreshEmailVerified reloads the user from Firebase; if even that fails we treat
            // the address as unverified, which is the safe answer.
            let alreadyVerified = false;
            try {
              alreadyVerified = await this.$store.dispatch('user/auth/refreshEmailVerified');
            } catch (reloadError) {
              alreadyVerified = false;
            }
            this.$router.push({ name: 'Dashboard' });
            if (alreadyVerified) {
              showSuccessNotification('Your email is already verified. Nothing else to do.', 3000);
            } else if (error.code === 'auth/invalid-action-code') {
              showErrorNotification('That verification link has expired or was already used. Open Profile and send yourself a new one.', 8000);
            } else {
              showErrorNotification(error.message, 8000);
            }
          }
          break;
        }
        default: // Error: invalid mode.
          showErrorNotification('Invalid mode.', 8000);
      }
    } catch (error) { // Catch allEvents rejected promises
      this.$router.push({ name: 'Dashboard' });
      showErrorNotification(error.message, 8000);
    }
  },
};
</script>

<style scoped>
</style>
